import { Button, Divider, Stack } from "@mui/material";
import { ReactComponent as Warning } from "../../../../Assets/Images/WarningICON.svg";
import { CommonMessage } from "../../../atoms/CommonMessage/CommonMessage";
import { HorizontalDivide } from "../../../atoms/HorizontalDivide/HorizontalDivide";

export const DcsNoContent = ({ t, setContentID, type }) => {
  return (
    <>
      <Stack direction={"column"}>
        <CommonMessage
          icon={<Warning width={"16px"} height={"16px"} />}
          text={t("validation:please-include-consult-rate")}
          widthIconcell={"auto"}
          spacing={1}
        />
        <HorizontalDivide marginTop={"23px"} marginBottom={"20px"} />
        <Button
          onClick={() => {
            setContentID({
              sceneID: 1,
              isUpdate: false,
              id: "",
            });
          }}
          variant="primaryBlue"
          sx={{ borderRadius: "8px" }}
        >
          {`Add  ${type} consultation rate`}
        </Button>
      </Stack>
      <Divider style={{ width: "100%", marginBottom: "20px" }} />
    </>
  );
};